// Shaped like real deliveries: subscription.* events carry planId and customerId populated
const generateSampleData = (eventType) => {
  const now = new Date().toISOString()
  const periodEnd = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
  const trialEnd = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString()

  const sampleCustomer = {
    _id: "cust_sample123",
    organizationId: "org_sample456",
    name: "Jane Smith",
    email: "jane@acme.com",
    externalId: "ext_001",
    status: "active",
    isDeleted: false,
    deletedAt: "2026-01-01T00:00:00.000Z",
    parentId: "cust_parent000",
    creditLimit: -1,
    contactPerson: { name: "Jane Smith", email: "jane@acme.com", phone: "+1234567890" },
    address: { line1: "123 Main St", city: "San Francisco", state: "CA", postalCode: "94105", country: "US" },
    billingInfo: { currency: "USD", taxExempt: "none", paymentMethods: [] },
    metadata: {},
    createdAt: now,
    updatedAt: now,
  }

  const sampleSubscription = {
    _id: "sub_sample789",
    organizationId: "org_sample456",
    customerId: {
      _id: "cust_sample123",
      organizationId: "org_sample456",
      name: "Jane Smith",
      email: "jane@acme.com",
      externalId: "ext_001",
      status: "active",
      isDeleted: false,
      deletedAt: "2026-01-01T00:00:00.000Z",
      parentId: "cust_parent000",
      creditLimit: -1,
      contactPerson: { name: "Jane Smith", email: "jane@acme.com", phone: "+1234567890" },
      address: { line1: "123 Main St", city: "San Francisco", state: "CA", postalCode: "94105", country: "US" },
      billingInfo: { currency: "USD", taxExempt: "none", paymentMethods: [] },
      metadata: {},
      createdAt: now,
      updatedAt: now,
    },
    planId: {
      _id: "plan_sample321",
      organizationId: "org_sample456",
      name: "Pro",
      description: "Pro plan",
      planType: "paid",
      planCategory: "regular",
      monthlyPrice: 49.99,
      annualPrice: 499,
      currency: "USD",
      trialDays: 14,
      isActive: true,
      isDefault: false,
      creditAllowance: 1000,
      maxUsers: 10,
      features: ["feature_a", "feature_b"],
      createdAt: now,
      updatedAt: now,
    },
    status: "active",
    price: 49.99,
    currency: "USD",
    billingCycle: "monthly",
    quantity: 1,
    autoRenew: true,
    cancelAtPeriodEnd: false,
    paymentFailureCount: 0,
    renewalAttempts: 0,
    startDate: now,
    currentPeriodStart: now,
    currentPeriodEnd: periodEnd,
    nextCreditResetDate: periodEnd,
    lastCreditResetDate: now,
    isDeleted: false,
    deletedAt: "2026-01-01T00:00:00.000Z",
    metadata: {},
    createdAt: now,
    updatedAt: now,
  }

  const samples = {
    "customer.created": sampleCustomer,
    "customer.updated": { ...sampleCustomer, status: "inactive", isDeleted: true, deletedAt: now },
    "subscription.canceled": {
      ...sampleSubscription,
      status: "canceled",
      canceledAt: now,
      cancelReason: "Customer requested cancellation",
      cancelType: "immediate",
    },
    "subscription.payment_failed": {
      ...sampleSubscription,
      status: "past_due",
      stripeStatus: "past_due",
      lastPaymentFailureDate: now,
    },
    "subscription.payment_succeeded": {
      ...sampleSubscription,
      status: "active",
      paymentFailureCount: 0,
      lastPaymentFailureDate: "2026-01-01T00:00:00.000Z",
    },
    // Stripe trials are stored as active — the trial shows only in trialEndDate
    "subscription.trial_ending": {
      ...sampleSubscription,
      status: "active",
      trialEndDate: trialEnd,
    },
    "subscription.activated": {
      ...sampleSubscription,
      status: "active",
      previousSubscriptionId: "sub_previous000",
    },
    "subscription.plan_changed": {
      ...sampleSubscription,
      previousPlanId: "plan_previous000",
    },
    "subscription.upcoming_renewal": sampleSubscription,
  }

  return samples[eventType] || { _id: "sample_id", createdAt: now }
}

// The envelope of every real delivery (server/services/webhook.service.js triggerWebhook)
export const buildSamplePayload = (eventType) => ({
  event: eventType,
  timestamp: Date.now(),
  data: generateSampleData(eventType),
})
